import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {FinancialPosition} from "../../models/financial-position";
import {
  ArcElement,
  CategoryScale,
  Chart,
  DoughnutController,
  Legend,
  Title,
  Tooltip,
} from "chart.js";
import {CurrencyService} from "../../../tandem-core/services/currency.service";
import {ChartService, DoughnutChartData} from "../../../tandem-core/services/chart.service";
import {FinancialPositionService} from "../../services/financial-position.service";
import {EChartsOption} from "echarts";
import {DateService} from "../../../tandem-core/services/date.service";

@Component({
  selector: 'tandem-financial-position-graph',
  templateUrl: './financial-position-graph.component.html',
  styleUrls: ['./financial-position-graph.component.scss']
})
export class FinancialPositionGraphComponent implements AfterViewInit {

  @Input() financialPosition: FinancialPosition | undefined;
  @Input() omitLegend: boolean | undefined;
  @Input() omitLabelLines: boolean = false;
  @Input() showSubtitle: boolean = false;
  @Input() showLegend: boolean = false;
  @Input() isSampleData: boolean = false;

  chart: any;

  chartOption: EChartsOption | null = null;

  constructor(private chartService: ChartService, private currencyService: CurrencyService, private fpService: FinancialPositionService, private dateService: DateService) {
  }
  ngOnInit() {
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      let categories: any[] = [];
      this.financialPosition?.assets.forEach(cat => {
        let total = cat.assets.reduce((accumulator, asset) => accumulator + asset.value, 0)
        if (total > 0) {
          categories.push({
            name: cat.name,
            value: total,
            isRevenue: true,  // Assets are revenue-like
            parentSection: 'Assets'  // Link to inner series section
          })
        }
      })
      this.financialPosition?.liabilities.forEach(cat => {
        let total = cat.liabilities.reduce((accumulator, liability) => accumulator + liability.value, 0)
        if (total > 0) {
          categories.push({
            name: cat.name,
            value: total,
            isRevenue: false,  // Liabilities are expense-like
            parentSection: 'Liabilities'  // Link to inner series section
          })
        }
      })

      const innerSeries = {
        name: 'Items',
        data: [
          {
            name: 'Assets',
            value: this.financialPosition?.totalAssets || 0,
            isRevenue: true  // Assets are revenue-like
          },
          {
            name: 'Liabilities',
            value: this.financialPosition?.totalLiabilities || 0,
            isRevenue: false  // Liabilities are expense-like
          },
        ]
      };
      const outerSeries = {
        name: 'Categories',
        data: categories,
        greenItemCount: this.financialPosition?.assets.filter(cat => cat.assets.reduce((accumulator, asset) => accumulator + asset.value, 0) > 0).length || 0,
        redItemCount: this.financialPosition?.liabilities.filter(cat => cat.liabilities.reduce((accumulator, liability) => accumulator + liability.value, 0) > 0).length || 0,
        yellowItemCount: 0,
        orangeItemCount: 0
      };

      this.chartOption = this.chartService.generatePieChart(innerSeries,
        outerSeries,
        this.showLegend,
        this.omitLabelLines
      );

      // if (this.financialPosition) {
      //   this.chart = this.chartService
      //     .generateDoughnutChart('fpChartCanvas',
      //       {label: 'Net Worth: ',value: this.financialPosition!.netWorth},
      //       this.fpService.convertFinancialPositionToChartData(this.financialPosition!), 2, this.omitLegend);
      // }
    });
  }

  getTitle() {
    return `Net Worth: ${this.currencyService.formatNumber(this.financialPosition?.netWorth || 0)}`;
  }

  getSubtitle() {
    return this.showSubtitle ? `As of ${this.dateService.formatTimestamp(this.financialPosition!.positionDate)}` : undefined;
  }
}
